var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIpWhitelist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "97px",
    viewBox: "0 0 128 97",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/primary/ip-whitelist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/primary/ip-whitelist",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "folder",
    fill: "#4b6922",
    fillRule: "nonzero",
    points: "0 0 32.7656029 0 40.7502932 8 117.774182 8 117.774182 20 113.781837 20 113.781837 12 39.0966097 12 31.1119194 4 3.99234514 4 4.03139818 91 113.996977 91 121.525399 26 19.9617257 26 19.9617257 22 126 22 117.559042 95 0.039053036 95"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "folder",
    fill: "#4b6922",
    fillRule: "nonzero",
    points: "0 0 32.7656029 0 40.7502932 8 117.774182 8 117.774182 20 113.781837 20 113.781837 12 39.0966097 12 31.1119194 4 3.99234514 4 4.03139818 91 113.996977 91 121.525399 26 19.9617257 26 19.9617257 22 126 22 117.559042 95 0.039053036 95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "labels",
    transform: "translate(20.000000, 45.000000)",
    fill: "#4b6922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ip",
    transform: "translate(0.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "48 0 64 0 64 4 48 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "24 0 40 0 40 4 24 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "0 0 16 0 16 4 2.72240143e-14 4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "box",
    opacity: 0.5,
    x: 66,
    y: 0,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "box",
    opacity: 0.5,
    x: 42,
    y: 0,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "box",
    opacity: 0.5,
    x: 18,
    y: 0,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "72 0 88 0 87.5151515 4 72 4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ip",
    transform: "translate(2.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "48 0 64 0 64 4 48 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "24 0 40 0 40 4 24 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "0 0 16 0 16 4 2.72240143e-14 4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "box",
    opacity: 0.5,
    x: 66,
    y: 0,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "box",
    opacity: 0.5,
    x: 42,
    y: 0,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "box",
    opacity: 0.5,
    x: 18,
    y: 0,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "72 0 88 0 87.5151515 4 72 4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ip",
    transform: "translate(4.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "48 0 64 0 64 4 48 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "24 0 40 0 40 4 24 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "0 0 16 0 16 4 2.72240143e-14 4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "box",
    opacity: 0.5,
    x: 66,
    y: 0,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "box",
    opacity: 0.5,
    x: 42,
    y: 0,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "box",
    opacity: 0.5,
    x: 18,
    y: 0,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "box",
    points: "72 0 88 0 87.5151515 4 72 4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpWhitelist);
export default __webpack_public_path__ + "static/media/ip-whitelist.788c8f4cd32f3945eed07a0d1425a3fb.svg";
export { ForwardRef as ReactComponent };